import { render, staticRenderFns } from "./HangingClosetLattices.vue?vue&type=template&id=c87c6ff0&scoped=true&"
import script from "./HangingClosetLattices.vue?vue&type=script&lang=js&"
export * from "./HangingClosetLattices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87c6ff0",
  null
  
)

export default component.exports